import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const NavArrowLeftSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps): JSX.Element => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8481 6.96552C22.8535 7.59374 22.6086 8.2005 22.1629 8.66339L14.8784 16.0001L22.1629 23.3369C22.6092 23.7984 22.8569 24.4031 22.8569 25.0307C22.8569 25.6583 22.6092 26.2629 22.1629 26.7245C21.9494 26.9464 21.6898 27.1236 21.4007 27.2449C21.1115 27.3661 20.799 27.4287 20.4831 27.4287C20.1672 27.4287 19.8547 27.3661 19.5655 27.2449C19.2763 27.1236 19.0168 26.9464 18.8033 26.7245L9.83994 17.6931C9.39175 17.2334 9.14265 16.6292 9.14265 16.0018C9.14265 15.3743 9.39175 14.7701 9.83994 14.3104L18.7947 5.27582C19.0082 5.05387 19.2678 4.87665 19.5569 4.75541C19.8461 4.63417 20.1586 4.57157 20.4745 4.57157C20.7904 4.57157 21.1029 4.63417 21.3921 4.75541C21.6813 4.87665 21.9408 5.05387 22.1543 5.27582C22.5995 5.73577 22.8444 6.33982 22.8396 6.96552"
        fill={fill}
      />
    </svg>
  </span>
);

export default NavArrowLeftSVG;
